/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Fix_Price_NowInputs */

const en_fix_price_now = /** @type {(inputs: Fix_Price_NowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Now ${i?.price} per kg`)
};

const de_fix_price_now = /** @type {(inputs: Fix_Price_NowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktuell ${i?.price} pro kg`)
};

/**
* | output |
* | --- |
* | "Now {price} per kg" |
*
* @param {Fix_Price_NowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_price_now = /** @type {((inputs: Fix_Price_NowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_Price_NowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_price_now(inputs)
	return en_fix_price_now(inputs)
});